export const styleConfig = {
    ipadPro: {
        grantsTab: {
            defaultWidth: 80,
            customStyles: [
                {
                    column: 2,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 3,
                    textAlign: 'right',
                    sorterPos: 51,
                    width: 120
                },
                {
                    column: 4,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 95
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 94
                }
            ]
        },
        grantsSchedule: {
            defaultWidth: 65,
            customStyles: [
                {
                    column: 3,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 66,
                    width: 135
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 7,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 50
                }
            ]
        },
        grantsAgreement: {
            defaultWidth: 90,
            customStyles: [
                {
                    column: 3,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 3,
                    width: 135
                },
                {
                    column: 5,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 94
                }
            ]
        }        
    },
    desktop: {
        grantsTab: {
            defaultWidth: 97,
            customStyles: [
                {
                    column: 2,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 3,
                    textAlign: 'right',
                    sorterPos: 61,
                    width: 130
                }
            ]
        },
        grantsSchedule: {
            defaultWidth: 77,
            customStyles: [
                {
                    column: 3,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 66,
                    width: 135
                },
                {
                    column: 6,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 7,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 50
                }             
            ]
        },
        grantsAgreement: {
            defaultWidth: 77,
            customStyles: [
                {
                    column: 2,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 82
                },
                {
                    column: 3,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 98
                },
                {
                    column: 4,
                    textAlign: 'right',
                    sorterPos: 3,
                    width: 135
                },
                {
                    column: 5,
                    textAlign: 'left',
                    sorterPos: null,
                    width: 94
                }
            ]
        }
    }
  }